import React from "react";

export default function FormatDate({setDate, format, isEmpty = false}) {

    let date;

    if (!format)
        format = {day: 'numeric', month: 'numeric', year: 'numeric'};

    if (isEmpty && !setDate) {
        date = <span>—</span>;
    } else if (setDate) {
        date = new Date(setDate).toLocaleString('ru', format);
    } else {
        date = new Date().toLocaleString('ru', format);
    }

    return date;
}


// WEBPACK FOOTER //
// ./src/Components/Utils/FormatDate/index.js